module.exports = __webpack_public_path__ + "static/media/featureZoom.6c62f76d.png";